import { render, staticRenderFns } from "./SendAttendanceSurvey.vue?vue&type=template&id=2da19597&scoped=true&"
import script from "./SendAttendanceSurvey.vue?vue&type=script&lang=js&"
export * from "./SendAttendanceSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da19597",
  null
  
)

export default component.exports